// extracted by mini-css-extract-plugin
module.exports = {"button":"button-03d28a20"};